import { token } from '@cp/shared/di';
import { AsyncResult, Result } from '@cp/shared/result';
import { ClientProfileViewModel } from '@common/model/client';
import { ClientRegistrationState } from '@common/model/client/registration/registrationState';
import { ClientSelection } from './model';

export const REGISTRATION_FEATURE =
  token<(sessionId: string, initialState: Partial<ClientRegistrationState>) => Promise<Result<ClientProfileViewModel, Error>>>(
    'REGISTRATION_FEATURE',
  );

export const CLIENT_SELECTION_GETTER = token<() => Promise<ClientSelection>>('CLIENT_SELECTIONS');
export const DEVICE_IDENTIFIER = token<() => Promise<string>>('DEVICE_IDENTIFIER');
export const QUIZ_FEATURE = token<(q: Array<keyof ClientSelection>) => AsyncResult<ClientSelection, Error>>('auth/QUIZ_FEATURE');
